var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notification-base-list',{attrs:{"ExtraListParams":_vm.ExtraListParams,"extra-columns":_vm.ExtraColumns,"ExtraExportDataOptions":_vm.ExtraExportDataOptions,"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }